export default {
  apiGateway: {
    REGION: "eu-central-1",
    URL: "https://8i2ccuyja9.execute-api.eu-central-1.amazonaws.com/prod"
  }
};